module.exports = __webpack_public_path__ + "img/icons/manifest.json";


/*****************
 ** WEBPACK FOOTER
 ** ./app/static/images/icons/manifest.json
 ** module id = 72
 ** module chunks = 0
 **/